import axios from 'axios';
import {
  REQUEST_TRACKER_TRANSACTIONS,
  RECEIVED_TRACKER_TRANSACTIONS_SUCCESS,
  RECEIVED_TRACKER_TRANSACTIONS_ERROR,
} from '../commonActionTypes';

//  Tracker Actions
const requestTrackerTransactions = () => ({ type: REQUEST_TRACKER_TRANSACTIONS });

const receivedTrackerTransactionsError = () => ({ type: RECEIVED_TRACKER_TRANSACTIONS_ERROR });

const receivedTrackerTransactions = (responseData, configs) => ({
  payload: {
    responseData,
    configs,
  },
  type: RECEIVED_TRACKER_TRANSACTIONS_SUCCESS,
});

// get all the tracker transactions for logged in user.
const fetchTrackerTransactions = () => (dispatch) => {
  dispatch(requestTrackerTransactions());

  return axios.get('/smarthelp/refund-fetch')
    .then((response) => {
      const responseData = (response || {}).data || {};
      dispatch(receivedTrackerTransactions(responseData.items, responseData.configs));
    })
    .catch(() => {
      dispatch(receivedTrackerTransactionsError());
    });
};

export default fetchTrackerTransactions;
